import React from 'react';
function Regestration() {
  return (
    <div className="container mx-auto pl-3 pr-3 py-3 bg-cover pt-20 sm:pt-4 bg-no-repeat w-full" style={{ backgroundImage: 'url(https://chandigarhengineeringcollege.com/public/course/assets/images/cec/club-bg.png)' }}>
  <div className="container mx-auto py-3 bg-cover bg-no-repeat w-full" style={{ backgroundImage: 'url(https://chandigarhengineeringcollege.com/public/course/assets/images/cec/club-bg.png)' }}>
    <h1 className="text-2xl sm:text-3xl font-bold mb-5 text-center">REGISTRATION</h1>
    <div className="overflow-x-auto mb-5">
      <div className="flex justify-center">
        <table className="table-auto w-full max-w-4xl border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 p-2 text-xs sm:text-base">Delegates</th>
              
              <th colSpan={2} className="border border-gray-300 p-2 text-xs sm:text-base">Indian Authors (Rs.)</th>
              <th colSpan={2} className="border border-gray-300 p-2 text-xs sm:text-base">Foreign Authors (USD)</th>
              <th colSpan={2} rowSpan={2} className="border border-gray-300 p-2 text-xs sm:text-base">Indian Attendees (Rs.)</th>
              <th colSpan={2} rowSpan={2} className="border border-gray-300 p-2 text-xs sm:text-base">Foreign Attendees (USD)</th>
              
            </tr>
            <tr className="bg-gray-200">
            <th className="border border-gray-300 p-2 text-xs sm:text-base">Category of Author</th>
              <th className="border border-gray-300 p-2 text-center text-xs sm:text-base">IEEE Member</th>
              <th className="border border-gray-300 p-2 text-center text-xs sm:text-base">Non-IEEE Member</th>
              <th className="border border-gray-300 p-2 text-center text-xs sm:text-base">IEEE Member</th>
              <th className="border border-gray-300 p-2 text-center text-xs sm:text-base">Non-IEEE Member</th>
              

            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">Student (UG/PG)</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">6000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">7000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">200</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">250</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">1000</td>
              <td colSpan={2} className="border border-gray-300 p-2 text-center text-xs sm:text-base">50</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">Research Scholar (PhD)</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">7000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">8000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">250</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">300</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">1500</td>
              <td colSpan={2} className="border border-gray-300 p-2 text-center text-xs sm:text-base">100</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">Academia/Faculty</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">8000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">9000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">300</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">350</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">2000</td>
              <td colSpan={2} className="border border-gray-300 p-2 text-center text-xs sm:text-base">150</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">Delegates from Industry</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">9000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">10000</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">350</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">400</td>
              <td className="border border-gray-300 p-2 text-center text-xs sm:text-base">2500</td>
              <td colSpan={2} className="border border-gray-300 p-2 text-center text-xs sm:text-base">200</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    { /* <div className="text-right">
      <i className="text-xs sm:text-sm mt-4">* Technical sponsorship from IEEE Delhi Section</i>
    </div> */ }
  </div>
  <div className="bg-gray-100 p-3 sm:p-5 rounded-lg shadow-lg">
    <p className="mb-2 text-xs sm:text-base"><strong>Account Name:</strong> Chandigarh Engineering College</p>
    <p className="mb-2 text-xs sm:text-base"><strong>Bank Name:</strong> State Bank of India</p>
    <p className="mb-2 text-xs sm:text-base"><strong>Account number:</strong> 39625129110</p>
    <p className="mb-2 text-xs sm:text-base"><strong>IFSC Code:</strong> SBIN0017008</p>
    <p className="mb-2 text-xs sm:text-base"><strong>MICR Code:</strong> 160002082</p>
    <p className="mb-2 text-xs sm:text-base"><strong>Bank Name and Address:</strong> Jhanjeri, Sirhind Road 140307</p>
  </div>
  <p className="text-center mt-5 text-xs sm:text-base">
    <strong>Note:</strong> After making payment, participants are requested to share transaction details along with paper ID <a target="_blank" href='https://forms.gle/uYPY8fLwrtQkj5Nd9' className="cursor-pointer text-blue-600">Click Here</a>.
  </p>
</div>
  );
}  
export default Regestration;